import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import ko from 'vuetify/lib/locale/ko';
import mdiSvgIcons from './vuetify/mdiSvgIcons';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { ko },
    current: 'ko',
  },
  icons: mdiSvgIcons,
});
